import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_NSC_SUBJECT_SCHOOLS = gql`
  query ExportFunderNSCSubjectSchools($input: ExportArgs!) {
    allFunderNSCSubjectSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
